import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Badge,
  Dropdown,
  Tabs,
  Tab,
  Table,
  Form,
} from "react-bootstrap";
import openSocket from "socket.io-client";
import { useAuth } from "../../hooks/useAuth";
import { isEmpty, set } from "lodash";
import { useMutation, useQuery } from "react-query";
import {
  fetchActionsUtil,
  paginationOptions,
  convertToBaseCurrency,
} from "../../utils/helpers";
import { endOfToday, format, parse, startOfToday } from "date-fns";
import currency from "currency.js";
import useDebounce, { useCurrencies, useQueryParams } from "../../utils/hooks";
import { toast } from "react-toastify";
import { FilterIcon } from "../Icons";
import NoTableItem from "../utils/NoTableItem";
import ModalLoader from "../utils/ModalLoader";
import { IsPrivileged } from "../DisplayChildElement";
import queryString from "query-string";
import RsDateRangePicker from "../utils/RsDateRangePicker";
import ReactPaginate from "react-paginate";
import CachedIcon from "mdi-react/CachedIcon";
import ConfirmDialog from "../ConfirmDialogue";

import "../../assets/scss/reports/cashbook.scss";
import { appSettings } from "../../config";
import printJS from "print-js";
import { useStoreState } from "easy-peasy";
import moment from "moment";
import ConvertQuantity, { formatQuantity } from "../utils/ConvertQuantity";
import MagnifyIcon from "mdi-react/MagnifyIcon";

const OpenStashItems = () => {
  const { backendUrl } = useAuth();
  const [stashId, setStashId] = useState("");
  const [table, setTable] = useState([]);
  const { prevailingCurrencySymbol } = useCurrencies();
  const [updateOrderId, setUpdateOrderId] = useState("");
  const [notificationData, setNotificationData] = useState({});
  const [currentId, setCurrentId] = useState("");
  const generalSettings = useStoreState((state) => state.generalSettings);
  const { isIronRod } = useAuth();
  const itemMeasurements = useStoreState((state) => state.itemMeasurements);
  const uomConversions = useStoreState((state) => state.uomConversions);
  const initialFilterParams = {
    startDate: format(startOfToday(), "yyyy-MM-dd"),
    endDate: format(endOfToday(), "yyyy-MM-dd"),
    enableDateRange: true,
    stashId: "",
    stash: "",
  };
  const [currentPrint, setCurrentPrint] = useState("");
  const [isPrinting, setIsPrinting] = useState(false);
  const [queryParams, setQueryParams] = useQueryParams({
    page: 1,
    limit: 40,
    ...initialFilterParams,
  });
  const [filterParams, setFilterParams] = useState({
    ...initialFilterParams,
    ...queryParams,
    page: 1,
    limit: 40,
  });

  const { data, refetch, isLoading } = useQuery(
    ["GET_PENDING_OPEN_ORDERS", queryParams, stashId],
    () =>
      fetchActionsUtil(
        `${backendUrl}/api/items/stash-all?${queryString.stringify(
          queryParams,
        )}`,
        "GET",
      ),
    {
      onSuccess: async ({ data = [] }) => {
        let items = data.map(
          ({
            items,
            total,
            stash_id,
            nominee = [],
            customer = "",
            customerData = "{}",
            tableNumber = "",
            created_at = "",
          }) => ({
            items: items.map((item) => ({
              ...item,
              Item_Name: item?.data?.Item_Name,
              Item_id: item.Item_id,
              quantity: item?.data?.Quantity,
              price: item?.data?.PriceSold,
              SubTotal: item?.data?.SubTotal,
              data: item.data,
            })),
            id: stash_id,
            totalPrice: total,
            nominee: nominee,
            tableNumber,
            customer,
            customerData: customerData ? customerData : {},
            created_at,
          }),
        );

        setTable(items);
      },
      keepPreviousData: true,
    },
  );

  const debouncedFilterParams = useDebounce(filterParams, 500);
  useEffect(() => {
    setQueryParams({
      ...queryParams,
      ...debouncedFilterParams,
    });
  }, [debouncedFilterParams, setQueryParams]);

  const customStyles = {
    primaryBlue: "#2463ae",
    darkBlue: "#0a4a95",
    blackPrimary: "#0f172a",
    blackSecondary: "#334155",
    blackSubtle: "#94a3b8",
    light: "#e2e8f0",
    lighterPale: "#f8faff",
    bluePale: "#ecf4fe",
    baseWhite: "#ffffff",
    baseGrey30: "#ced8e1",
    baseGrey40: "#a7b9cb",
    baseGrey60: "#788898",
    lightBlue2: "#d8e6f5",
  };

  const filterByDateRange = (date) => {
    setFilterParams({
      ...filterParams,
      startDate: format(date[0], "yyyy-MM-dd"),
      endDate: format(date[1], "yyyy-MM-dd"),
      enableDateRange: true,
    });
  };
  const clearDateRange = () => {
    setFilterParams({
      ...filterParams,
      startDate: "",
      endDate: "",
    });
  };
  const TabButton = ({ id, label, icon: Icon, isActive, onClick }) => (
    <div
      role="button"
      className={`d-flex align-items-center gap-2 px-4 py-3 rounded-3 border-0 transition-all`}
      onClick={onClick}
      style={{
        backgroundColor: isActive ? "#2463ae" : "#ffffff",
        color: isActive ? "#ffffff" : "#334155",
        boxShadow: isActive
          ? "0 4px 15px rgba(36, 99, 174, 0.3)"
          : "0 2px 8px rgba(0,0,0,0.08)",
        cursor: "pointer",
        transform: isActive ? "translateY(-1px)" : "none",
        borderLeft: isActive ? "none" : "4px solid transparent",
        borderLeftColor:
          !isActive && id === filterParams?.status ? "#2463ae" : "transparent",
      }}
    >
      {Icon && <Icon size={18} />}
      <span className="fw-semibold">{label}</span>
    </div>
  );

  const printInvoice = async (payload) => {
    if (
      payload.currency &&
      payload.currency !== generalSettings?.prevailingCurrency
    ) {
      payload = convertToBaseCurrency({
        data: payload,
        conversionAmount: payload.conversionAmount,
      });
    }
    /*  console.log("JJ", payload);
        return; */
    // const isThermalPrinter =
    //   generalSettings.printerType?.toLowerCase() ===
    //   "Thermal Printer"?.toLowerCase();

    let response = await fetch(
      `${backendUrl}/api/invoice/view-invoice-for-none-posted-transactions?thermalPrinter=true`,
      {
        method: "POST",
        credentials: "include",
        body: JSON.stringify(payload),
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
        },
      },
    );
    if (!response.ok) {
      response = await response.json();
      // alert(JSON.stringify(response));
      throw new Error(JSON.stringify(response));
    }
    const res = await response.json();
    return res;
  };
  const handlePrint = async (dataN) => {
    let values = dataN || {};

    const tableData = values?.items?.map((el) => el.data);
    const subTotal = values?.totalPrice;
    const amountDue = values?.totalPrice;
    const amount = values?.totalPrice;

    // check customer for existing customers

    let customer = !isEmpty(values?.customerData)
      ? values?.customerData
      : {
          numberPrefix: null,
          currentNumber: null,
          Cust_ID: "",
          FirstName: "",
          MiddleName: "",
          LastName: values?.customer || "",
          DOB: "",
          PhoneNo1: "",
          PhoneNo2: null,
          CompanyAddress: "",
          ContactAddress: "",
          Office_PhoneNo: null,
          Email: "",
          Name_Add_work: null,
          Name_Add_sch: null,
          Highest_Qual: null,
          Name_Institution: null,
          Year_attained: null,
          How_Did_Know: "",
          TransType: "",
          Product_Int1: "None",
          Product_Int2: "None",
          FollowUpComment: "",
          DateLog: "",
          PhotoPath: null,
          Branch: "",
          Dept: "Sales",
          password: "",
          Gender: null,
          Post_Time: "",
          state: null,
          LGA: null,
          Group: "",
          referal_EmployeeID: null,
          verifyToken: null,
          onlineStoreInventorySource: "",
          onlineStoreInventorySourceName: "",
          country: null,
          customerApprovePendingOnlineOrders: false,
          Staff_ID: null,
        };

    const initialvalue = {
      tableNumber: values?.tableNumber,

      items: tableData,
      deliveryInformation: [
        {
          Vendor_ID: "",
          Vendor_Name: "",
          ServiceChargePerLitre: 0,
          Volume: 0,
          Total: 0,
          DriverName: "",
          TruckNumber: "",
          InhouseLoading: false,
          VolumeLoaded: 0,
          VolumeSupplied: 0,
          ShortageVolume: 0,
          EmployeeID: "",
        },
      ],
      taxType: tableData[0]?.taxType ? tableData[0]?.taxType : "None",
      creditLine: "",
      PaymentType: "Cash",
      proformaNumber: "",
      splitPaymentType: "",
      printWaybill: true,
      salesDate: moment(),
      invoiceCat: "",
      OverwriteOfficer: "Retail",
      chequeNumber: "",
      BankName: "",
      cashAmount: "",
      sendEmail: false,
      printReciept: true,
      dueIn: "",
      pendingTransaction: "",
      supplyNow: false,
      ShipTo: customer?.LastName || "Walk-In",
      customerBalance: "",
      amountToPayFromCustomerCredit: "0",
      printer: generalSettings.printerType,
      posCharge: 0,
      loadingCharge: "",
      offloadingCharge: "",
      isBatchStandard: appSettings.isBatchStandard,
      transportCharge: "",
      Sale_Rep: "",
      Sale_Rep_Name: "",
      shippingCost: 0,
      otherCharges: 0,
      splitPaymentCardArray: [
        {
          amount: "",
          bank: "",
          posCharge: "",
          fixedAmount: "",
        },
      ],
      splitDirectBankTransferArray: [
        {
          amount: "",
          bank: "",
        },
      ],
      splitPaymentChequeArray: [
        {
          amount: "",
          bank: "",
          chequeNumber: "",
        },
      ],
      Bar_Code: "",
      currency: generalSettings?.prevailingCurrency,
      linkedPaymentID: "",
      jobNumber: "",
      poNumber: "", // GA
      milestone: "",
      conversionAmount: generalSettings.dollarInBaseCurrency,

      lockBank: false,
      itemSearchCriteria: "Item_Code",
      amountFromCustomerBalance: 0,
      bankOnInvoice: "",
      taxes: [],
      generalDiscountType: "Fixed",
      generalDiscount: 0,
      generalDiscountPercentage: "",
      selectedAccountToPost: null,
      amountPaid: 0,
      summaryFromMultiplePayments: {},
      subTotal,
      discount: 0,
      amountDue,
      profit: "0",
      balance: "0.00",
      amount,
      customer: customer,
      taxValue: tableData[0]?.taxValue || "0.000",
      costOFSales: amount,
      salesIncome: 0,
      isRod: true,
      otherTaxValues: tableData[0]?.otherTaxValues
        ? tableData[0]?.otherTaxValues
        : [],
    };
    setCurrentId(values?.id);

    try {
      setIsPrinting(true);
      // setIstash()
      const data = await printInvoice(initialvalue);
      printJS({
        printable: data.html,
        type: "raw-html",
        targetStyles: ["*"],
      });
    } catch (error) {
    } finally {
      setIsPrinting(false);
      setCurrentId("");
    }
  };

  const handleSearchQueryChange = (e) => {
    setFilterParams({
      ...filterParams,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <IsPrivileged
      roleName={["POS", "Restaurant Orders", "Customer List", "Open Order"]}
    >
      <div
        style={{
          backgroundColor: customStyles.lighterPale,
          minHeight: "100vh",
          padding: "2rem 0",
        }}
      >
        <main className="cash-book">
          <div className="">
            <div className="p-3">
              <div>
                <Row className="mb-4">
                  <Col>
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <h2
                          className="mb-2 fw-bold"
                          style={{
                            color: customStyles.blackPrimary,
                            fontSize: "2rem",
                          }}
                        >
                          Open Orders <CachedIcon onClick={() => refetch()} />
                        </h2>
                        <p
                          className="mb-0"
                          style={{
                            color: customStyles.baseGrey60,
                            fontSize: "1rem",
                          }}
                        >
                          Manage open orders
                        </p>
                      </div>
                      <div className="d-flex align-items-center gap-3">
                        <div className="position-relative">
                          <RsDateRangePicker
                            placement="bottomStart"
                            value={
                              filterParams.startDate && filterParams.endDate
                                ? [
                                    parse(
                                      filterParams.startDate,
                                      "yyyy-MM-dd",
                                      new Date(),
                                    ),
                                    parse(
                                      filterParams.endDate,
                                      "yyyy-MM-dd",
                                      new Date(),
                                    ),
                                  ]
                                : []
                            }
                            onClean={() => clearDateRange()}
                            onOk={(date) => filterByDateRange(date)}
                          />
                        </div>

                        <div className="global-search-area">
                          <MagnifyIcon />
                          <Form.Control
                            id="queryParams-q"
                            className="  "
                            name="table"
                            value={filterParams.LastName}
                            onChange={(e) => handleSearchQueryChange(e)}
                            placeholder="Search by table no"
                          />
                        </div>

                        <Badge
                          bg="light"
                          text="dark"
                          className="px-3  h-100 "
                          style={{
                            backgroundColor: customStyles.lightBlue2,
                            color: customStyles.primaryBlue,
                            fontSize: "0.9rem",
                            fontWeight: "600",
                            textTransform: "capitalize",
                            paddingTop: "12px",
                            paddingBottom: "12px",
                          }}
                        >
                          {table?.length} Open Orders
                        </Badge>
                        {/* <Dropdown>
                      <Dropdown.Toggle
                        variant="outline-secondary"
                        className="bg-white  border"
                        bsPrefix=""
                        type="button"
                      >
                        <FilterIcon /> Filter
                      </Dropdown.Toggle>
                      <Dropdown.Menu
                        popperConfig={{
                          strategy: "fixed",
                        }}
                        renderOnMount
                        className="dropdown-with-icons"
                      >
                        <Dropdown.Item
                          as="button"
                          type="button"
                          onClick={() =>
                            setFilterParams({
                              ...filterParams,
                              status: "all",
                            })
                          }
                        >
                          All
                        </Dropdown.Item>
                        <Dropdown.Item
                          as="button"
                          type="button"
                          onClick={() =>
                            setFilterParams({
                              ...filterParams,
                              status: "pending",
                            })
                          }
                        >
                          Pending
                        </Dropdown.Item>
                        <Dropdown.Item
                          as="button"
                          type="button"
                          onClick={() =>
                            setFilterParams({
                              ...filterParams,
                              status: "completed",
                            })
                          }
                        >
                          Completed
                        </Dropdown.Item>
                        <Dropdown.Item
                          as="button"
                          type="button"
                          onClick={() =>
                            setFilterParams({
                              ...filterParams,
                              status: "canceled",
                            })
                          }
                        >
                          Canceled
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown> */}
                        {/* <div className="d-flex justify-content-end gap-2">
                          <TabButton
                            id="all"
                            label="All"
                            isActive={filterParams.status === "all"}
                            onClick={() =>
                              setFilterParams({
                                ...filterParams,
                                status: "all",
                                stashId: "",
                              })
                            }
                          />
                          <TabButton
                            id="pending"
                            label="Pending"
                            isActive={filterParams.status === "pending"}
                            onClick={() =>
                              setFilterParams({
                                ...filterParams,
                                status: "pending",
                                stashId: "",
                              })
                            }
                          />
                          <TabButton
                            id="completed"
                            label="Completed"
                            isActive={filterParams.status === "completed"}
                            onClick={() =>
                              setFilterParams({
                                ...filterParams,
                                status: "completed",
                                stashId: "",
                              })
                            }
                          />
                          <TabButton
                            id="canceled"
                            label="Canceled"
                            isActive={filterParams.status === "canceled"}
                            onClick={() =>
                              setFilterParams({
                                ...filterParams,
                                status: "canceled",
                                stashId: "",
                              })
                            }
                          />
                        </div> */}
                        {/* <Tabs
                          activeKey={filterParams.status}
                          onSelect={(k) =>
                            setFilterParams({
                              ...filterParams,
                              status: k,
                              stashId: "",
                            })
                          }
                          className="mb-3"
                        >
                          <Tab eventKey="all" title="All" />
                          <Tab eventKey="pending" title="Pending" />
                          <Tab eventKey="completed" title="Completed" />
                          <Tab eventKey="canceled" title="Canceled" />
                        </Tabs> */}
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row />

                <Row className="g-4">
                  {table?.map((order) => (
                    <Col key={order?.id} lg={4} md={6} sm={12}>
                      <Card
                        className="h-100 shadow-sm border-0"
                        style={{
                          backgroundColor: customStyles.baseWhite,
                          borderRadius: "12px",
                          transition:
                            "transform 0.2s ease, box-shadow 0.2s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "translateY(-2px)";
                          e.currentTarget.style.boxShadow =
                            "0 8px 25px rgba(15, 23, 42, 0.1)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow =
                            "0 1px 3px rgba(0, 0, 0, 0.1)";
                        }}
                      >
                        <Card.Body className="p-4">
                          <div className="d-flex justify-content-between align-items-start mb-3">
                            <div>
                              <h5
                                className="mb-1 fw-bold"
                                style={{ color: customStyles.blackPrimary }}
                              >
                                Table No: {order?.tableNumber}
                              </h5>
                              <p
                                className="fw-semibold"
                                style={{
                                  color: customStyles.blackPrimary,
                                  fontSize: "0.9rem",
                                }}
                              >
                                <span>
                                  Date:
                                  {format(
                                    new Date(order?.created_at),
                                    "dd-MMM-yyy",
                                  )}
                                </span>{" "}
                                <br />
                                <span>
                                  Time:
                                  {format(
                                    new Date(order?.created_at),
                                    "hh:mm a",
                                  )}
                                </span>
                              </p>
                            </div>
                            <Button
                              size="sm"
                              className=" px-3  "
                              onClick={() => handlePrint(order)}
                            >
                              {isPrinting && currentId === order?.id
                                ? "Printing..."
                                : "Print"}
                            </Button>
                            <Badge
                              className={`rounded-pill px-3 py-2 
                            ${
                              order?.status === "pending"
                                ? "bg-primary"
                                : order?.status === "completed"
                                ? "bg-success"
                                : "bg-danger"
                            }`}
                              style={{
                                backgroundColor: customStyles.bluePale,
                                color: customStyles.light,
                                fontSize: "0.75rem",
                                fontWeight: "600",
                              }}
                            >
                              {order?.status}
                            </Badge>
                          </div>

                          <div className="mb-4">
                            <Table borderless>
                              <thead>
                                <tr
                                  style={{
                                    color: customStyles.blackSecondary,
                                    fontSize: "1.1rem",
                                  }}
                                >
                                  <th>Item Name</th>
                                  <th>Quantity</th>
                                  <th>Subtotal</th>
                                </tr>
                              </thead>
                              <tbody>
                                {order?.items?.map((item, index) => (
                                  <tr key={index}>
                                    <td
                                      style={{
                                        color: customStyles.blackSecondary,
                                        fontSize: "1.1rem",
                                      }}
                                    >
                                      {item?.Item_Name}
                                    </td>
                                    <td
                                      className="fw-semibold"
                                      style={{
                                        color: customStyles.blackPrimary,
                                        fontSize: "1.1rem",
                                      }}
                                    >
                                      <ConvertQuantity
                                        quantity={item?.data?.Quantity}
                                        desc={item?.data?.Item_Desc}
                                        convertNow={true}
                                        uomId={item?.data?.uomId}
                                      />
                                    </td>
                                    <td
                                      className="fw-semibold"
                                      style={{
                                        color: customStyles.blackPrimary,
                                        fontSize: "1.1rem",
                                      }}
                                    >
                                      {currency(item.SubTotal, {
                                        symbol: prevailingCurrencySymbol,
                                      }).format()}
                                    </td>
                                  </tr>
                                ))}

                                <tr className=" border-top">
                                  <td
                                    className="fw-semibold"
                                    style={{
                                      color: customStyles.blackSecondary,
                                      fontSize: "1.1rem",
                                    }}
                                  >
                                    <b> Total</b>
                                  </td>
                                  <td />
                                  <td
                                    className="fw-semibold"
                                    style={{
                                      color: customStyles.blackSecondary,
                                      fontSize: "1.1rem",
                                    }}
                                  >
                                    <b>
                                      {currency(order.totalPrice, {
                                        symbol: prevailingCurrencySymbol,
                                      }).format()}{" "}
                                    </b>
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          </div>

                          <div
                            className="d-flex justify-content-between align-items-center  py-3"
                            style={{
                              borderTop: `1px solid ${customStyles.light}`,
                            }}
                          >
                            <span
                              className="fw-bold"
                              style={{
                                color: customStyles.blackPrimary,
                                fontSize: "1.1rem",
                              }}
                            >
                              Customer Details
                              <br />
                              <span className=" fw-normal">
                                {order?.customerData?.FirstName || ""}{" "}
                                {order?.customerData?.LastName || ""}
                              </span>
                            </span>
                          </div>
                          {!isEmpty(order?.nominee) && (
                            <div>
                              <div className="mb-2">
                                <span
                                  className="fw-bold "
                                  style={{
                                    color: customStyles.blackPrimary,
                                    fontSize: "1.1rem",
                                  }}
                                >
                                  {order?.nominee?.length > 1
                                    ? "Nominees"
                                    : "Nominee"}
                                </span>
                              </div>

                              <>
                                {order?.nominee?.map((nom) => (
                                  <div className="d-flex justify-content-between align-items-center  mb-2">
                                    <span
                                      className="fw-bold"
                                      style={{
                                        color: customStyles.blackPrimary,
                                        fontSize: "1.1rem",
                                      }}
                                    >
                                      <span className=" fw-normal">
                                        {nom?.FirstName || ""}{" "}
                                        {nom?.LastName || ""}
                                      </span>
                                    </span>
                                  </div>
                                ))}
                              </>
                            </div>
                          )}

                          {/* <Button
                          className={`w-100 fw-semibold py-3 border-0 ${
                            order?.status === "completed"
                              ? " bg-success"
                              : " bg-danger"
                          }`}
                          style={{
                            fontSize: "0.95rem",
                          }}
                        >
                          {order?.status === "completed"
                            ? "Completed"
                            : "Canceled"}
                        </Button> */}
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}

                  {!isLoading && (
                    <div>
                      {isEmpty(table) ? (
                        <NoTableItem
                          queryParams={{}}
                          title={`No Open Orders`}
                        />
                      ) : null}
                    </div>
                  )}
                </Row>
              </div>

              {/* <div className="d-flex justify-content-center px-3 align-items-center pagination">
                <ReactPaginate
                  {...paginationOptions}
                  pageCount={Math.ceil(data?.count / queryParams.limit)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={0}
                  onPageChange={({ selected }) => {
                    document.body.scrollTop = document.documentElement.scrollTop = 0;
                    setQueryParams({
                      ...queryParams,
                      page: selected + 1,
                    });
                  }}
                  forcePage={queryParams.page - 1}
                />
              </div> */}
            </div>
          </div>
        </main>

        <ModalLoader
          show={isLoading}
          title={`Please wait, getting ${
            filterParams?.status
          } restaurant orders...`}
        />
      </div>
    </IsPrivileged>
  );
};

export default OpenStashItems;
